import {
  LinkNetsuiteCustomerWidget,
  NetsuiteInspectorItem,
  NetsuiteSalesOrdersWidget
} from 'Integrations/index'
import { useBillingScheduleAggregate } from 'BillingScheduleHome/utils/useBillingScheduleAggregate'
import { usePermissions } from 'lib/rbac'

export const BillingScheduleNetsuiteInspectorItem = (props: {
  billingScheduleId: string
}) => {
  const { customerId } = useNetsuiteInspectorItem(props)
  const { can } = usePermissions()
  const canUpdateIntegrations = can('org.billing:update')

  return (
    <NetsuiteInspectorItem>
      {customerId ? (
        <LinkNetsuiteCustomerWidget customerId={customerId} canUnlink={false} />
      ) : null}
      <NetsuiteSalesOrdersWidget
        billingScheduleId={props.billingScheduleId}
        disabled={!canUpdateIntegrations}
      />
    </NetsuiteInspectorItem>
  )
}

const useNetsuiteInspectorItem = (props: { billingScheduleId: string }) => {
  const billingScheduleAggregateQuery = useBillingScheduleAggregate({
    billingScheduleId: props.billingScheduleId,
    select: data => ({ customerId: data.billingSchedule.customerId })
  })

  return {
    customerId: billingScheduleAggregateQuery.data?.customerId
  }
}
